import PropTypes from 'prop-types';
import controlNames from '../controls/displayNames';
import compositeNames from './displayNames';
import panelNames from '../panels/displayNames';
import { childType } from './childValidation';
import responsiveComposites from '../responsive-composites/compositeDefinitions';
var CONTROLS = 'Controls';
var PANELS = 'Panels';
var compositeDefinitions = {
  ActionSetHorizontal: {
    displayName: compositeNames.ACTION_SET_HORIZONTAL,
    className: 'composite-action-set-horizontal',
    childrenTypes: [childType.optional(controlNames.CHECKBOX, controlNames.RICH_TEXT), childType.once(controlNames.BUTTON), childType.optional(controlNames.BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.CHECKBOX
    }, {
      category: CONTROLS,
      title: controlNames.RICH_TEXT
    }, {
      category: CONTROLS,
      title: controlNames.BUTTON
    }]
  },
  ActionSetHorizontalSpaced: {
    displayName: compositeNames.ACTION_SET_HORIZONTAL_SPACED,
    className: 'composite-action-set-horizontal-spaced',
    childrenTypes: [childType.multiple(controlNames.BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.BUTTON
    }]
  },
  ActionSetVertical: {
    displayName: compositeNames.ACTION_SET_VERTICAL,
    className: 'composite-action-set-vertical',
    childrenTypes: [childType.once(controlNames.BUTTON), childType.optional(controlNames.BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.BUTTON
    }]
  },
  ActionWithSymbol: {
    displayName: compositeNames.ACTION_WITH_SYMBOL,
    uxSemantic: 'C03A',
    className: 'composite-action-with-symbol',
    childrenTypes: [childType.once(controlNames.ACTION_WITH_SYMBOL)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.ACTION_WITH_SYMBOL
    }]
  },
  ActionWithSymbolLabeled: {
    displayName: compositeNames.ACTION_WITH_SYMBOL_LABELED,
    uxSemantic: 'C03',
    className: 'composite-action-with-symbol-labeled composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.ACTION_WITH_SYMBOL)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.ACTION_WITH_SYMBOL
    }]
  },
  AngleInputLabeled: {
    displayName: compositeNames.ANGLE_INPUT_LABELED,
    uxSemantic: 'C77',
    className: 'composite-angle-input-labeled',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.ANGLE_INPUT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.ANGLE_INPUT
    }]
  },
  Banner: {
    displayName: compositeNames.BANNER,
    uxSemantic: 'C06B',
    className: 'composite-banner composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.SECTION_DIVIDER)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.SECTION_DIVIDER
    }]
  },
  BannerPremium: {
    displayName: compositeNames.BANNER_PREMIUM,
    uxSemantic: 'CO6C',
    className: 'composite-banner-premium composite-with-info-icon',
    childrenTypes: [childType.once(compositeNames.SECTION_DIVIDER_WITH_INFO_ICON, controlNames.SECTION_DIVIDER)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.SECTION_DIVIDER
    } // { category: COMPOSITES, title: 'SectionDividerWithInfoIcon' }, TODO: add when composite page is added
    ]
  },
  BigPanelHeader: {
    displayName: compositeNames.BIG_PANEL_HEADER,
    uxSemantic: 'C01',
    className: 'composite-big-panel-header',
    childrenTypes: [childType.once(panelNames.PANEL_HEADER_CENTERED_TEXT), childType.optional(controlNames.PANEL_HEADER), childType.optional(panelNames.PANEL_HEADER_ILLUSTRATION)],
    includedComponents: [{
      category: PANELS,
      title: panelNames.PANEL_HEADER_CENTERED_TEXT
    }, {
      category: CONTROLS,
      title: controlNames.PANEL_HEADER
    }, {
      category: PANELS,
      title: controlNames.PANEL_HEADER_ILLUSTRATION
    }]
  },
  BigPanelHeaderWithIllustration: {
    displayName: compositeNames.BIG_PANEL_HEADER_WITH_ILLUSTRATION,
    uxSemantic: 'C01',
    className: 'composite-big-panel-header-with-illustration',
    childrenTypes: [childType.once(panelNames.PANEL_HEADER_CENTERED_TEXT), childType.once(panelNames.PANEL_HEADER_ILLUSTRATION)],
    includedComponents: [{
      category: PANELS,
      title: panelNames.PANEL_HEADER_CENTERED_TEXT
    }, {
      category: PANELS,
      title: panelNames.PANEL_HEADER_ILLUSTRATION
    }]
  },
  ButtonMedium: {
    displayName: compositeNames.BUTTON_MEDIUM,
    uxSemantic: 'C19B',
    className: 'composite-button-medium',
    childrenTypes: [childType.once(controlNames.BUTTON), childType.once(controlNames.TEXT_BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.BUTTON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_BUTTON
    }]
  },
  ButtonLargeFixedBottom: {
    displayName: compositeNames.BUTTON_LARGE_FIXED_BOTTOM,
    uxSemantic: 'C74',
    className: 'composite-button-large-fixed-bottom',
    childrenTypes: [childType.multiple(controlNames.BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.BUTTON
    }]
  },
  ButtonLargeLabeled: {
    displayName: compositeNames.BUTTON_LARGE_LABELED,
    uxSemantic: 'C19',
    className: 'composite-button-large-labeled composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.BUTTON
    }]
  },
  ButtonLarge: {
    displayName: compositeNames.BUTTON_LARGE,
    uxSemantic: 'C19A',
    className: 'composite-button-large composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.multiple(controlNames.BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.BUTTON
    }]
  },
  ButtonLeft: {
    displayName: compositeNames.BUTTON_LEFT,
    uxSemantic: 'C45',
    className: 'composite-button-left',
    childrenTypes: [childType.once(controlNames.BUTTON, controlNames.BACK_BUTTON, controlNames.TEXT_BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.BUTTON
    }, {
      category: CONTROLS,
      title: controlNames.BACK_BUTTON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_BUTTON
    }]
  },
  ButtonsGroup: {
    displayName: compositeNames.BUTTONS_GROUP,
    uxSemantic: 'C13A',
    className: 'composite-buttons-group composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.BUTTONS_GROUP)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.BUTTONS_GROUP
    }]
  },
  ButtonsGroupLabeled: {
    displayName: compositeNames.BUTTONS_GROUP_LABELED,
    uxSemantic: 'C13',
    className: 'composite-buttons-group-labeled composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL, controlNames.TEXT), childType.once(controlNames.BUTTONS_GROUP)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.TEXT
    }, {
      category: CONTROLS,
      title: controlNames.BUTTONS_GROUP
    }]
  },
  CornerRadiusInput: {
    displayName: compositeNames.CORNER_RADIUS_INPUT,
    uxSemantic: 'C76A',
    className: 'composite-corner-radius-input',
    childrenTypes: [childType.once(controlNames.CORNER_RADIUS_INPUT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.CORNER_RADIUS_INPUT
    }]
  },
  CornerRadiusInputLabeled: {
    displayName: compositeNames.CORNER_RADIUS_INPUT_LABELED,
    uxSemantic: 'C76',
    className: 'composite-corner-radius-input-labeled',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.CORNER_RADIUS_INPUT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.CORNER_RADIUS_INPUT
    }, {
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }]
  },
  CheckboxWithInfoIcon: {
    displayName: compositeNames.CHECKBOX_WITH_INFO_ICON,
    className: 'composite-checkbox-with-info-icon composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.CHECKBOX)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.CHECKBOX
    }]
  },
  CheckboxWithAction: {
    displayName: compositeNames.CHECKBOX_WITH_ACTION,
    className: 'composite-checkbox-with-action',
    childrenTypes: [childType.once(controlNames.CHECKBOX), childType.once(controlNames.CONTEXT_MENU)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.CHECKBOX
    }, {
      category: CONTROLS,
      title: controlNames.CONTEXT_MENU
    }]
  },
  CheckboxesLabeled: {
    displayName: compositeNames.CHECKBOXES_LABELED,
    uxSemantic: 'C11',
    className: 'composite-checkboxes-labeled composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL), childType.multiple(compositeNames.CHECKBOX_WITH_INFO_ICON, controlNames.CHECKBOX, compositeNames.CHECKBOX_INDENTED)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.CHECKBOX
    } // { category: COMPOSITES, title: 'CheckboxWithInfoIcon' }, //TODO: add when composite page exists
    ]
  },
  Checkboxes: {
    displayName: compositeNames.CHECKBOXES,
    uxSemantic: 'C11A',
    className: 'composite-checkboxes',
    childrenTypes: [childType.multiple(compositeNames.CHECKBOX_WITH_INFO_ICON, controlNames.CHECKBOX)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.CHECKBOX
    } // { category: COMPOSITES, title: 'CheckboxWithInfoIcon' }, //TODO: add when composite page exists
    ]
  },
  DatePickerLabeled: {
    displayName: compositeNames.DATE_PICKER_LABELED,
    uxSemantic: 'C03B',
    className: 'composite-date-picker-labeled composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.DATE_PICKER_INPUT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.DATE_PICKER_INPUT
    }]
  },
  DockLabeled: {
    displayName: compositeNames.DOCK_LABELED,
    uxSemantic: 'C35A',
    className: 'composite-dock-labeled composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.DOCK)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.DOCK
    }]
  },
  DropDownLabeled: {
    displayName: compositeNames.DROP_DOWN_LABELED,
    uxSemantic: 'C10',
    className: 'composite-dropdown-labeled composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL, controlNames.DROP_DOWN), childType.once(controlNames.DROP_DOWN)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.DROP_DOWN
    }],
    compositePageExists: true
  },
  DropDown: {
    displayName: compositeNames.DROP_DOWN,
    uxSemantic: 'C10A',
    className: 'composite-dropdown',
    childrenTypes: [childType.once(controlNames.DROP_DOWN)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.DROP_DOWN
    }]
  },
  DropDownWithButton: {
    displayName: compositeNames.DROP_DOWN_WITH_BUTTON,
    uxSemantic: 'C51A',
    className: 'composite-dropdown-with-button',
    childrenTypes: [childType.once(controlNames.DROP_DOWN), childType.once(controlNames.ACTION_WITH_SYMBOL)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.DROP_DOWN
    }, {
      category: CONTROLS,
      title: controlNames.ACTION_WITH_SYMBOL
    }]
  },
  DropDownWithButtonLabeled: {
    displayName: compositeNames.DROP_DOWN_WITH_BUTTON_LABELED,
    uxSemantic: 'C51',
    className: 'composite-dropdown-with-button-labeled composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL), childType.once(compositeNames.DROP_DOWN_WITH_BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.ACTION_WITH_SYMBOL
    } // { category: COMPOSITES, title: 'DropDownWithButton' }, /* TODO: add when composite page is added */
    ]
  },
  DropDownWithColorInput: {
    displayName: compositeNames.DROP_DOWN_WITH_COLOR_INPUT,
    uxSemantic: 'C53A',
    className: 'composite-dropdown-with-color-input',
    childrenTypes: [childType.once(controlNames.FONT_FAMILY_PICKER, controlNames.DROP_DOWN), childType.once(controlNames.COLOR_PICKER_INPUT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.FONT_FAMILY_PICKER
    }, {
      category: CONTROLS,
      title: controlNames.DROP_DOWN
    }, {
      category: CONTROLS,
      title: controlNames.COLOR_PICKER_INPUT
    }]
  },
  DropDownWithColorInputLabeled: {
    displayName: compositeNames.DROP_DOWN_WITH_COLOR_INPUT_LABELED,
    uxSemantic: 'C53',
    className: 'composite-dropdown-with-color-input-labeled',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL), childType.once(compositeNames.DROP_DOWN_WITH_COLOR_INPUT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.INFO_ICON
    } // { category: COMPOSITE, title: 'DropDownWithColorInput }, //TODO: add when there's a composite page
    ]
  },
  LinkButtonWithColorInput: {
    displayName: compositeNames.LINK_BUTTON_WITH_COLOR_INPUT,
    uxSemantic: 'C03D',
    className: 'composite-link-button-with-color-input',
    childrenTypes: [childType.once(controlNames.ACTION_WITH_SYMBOL), childType.once(controlNames.COLOR_PICKER_INPUT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.ACTION_WITH_SYMBOL
    }, {
      category: CONTROLS,
      title: controlNames.COLOR_PICKER_INPUT
    }]
  },
  LinkButtonWithColorInputLabeled: {
    displayName: compositeNames.LINK_BUTTON_WITH_COLOR_INPUT_LABELED,
    uxSemantic: 'C03C',
    className: 'composite-link-button-with-color-input-labeled',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(compositeNames.LINK_BUTTON_WITH_COLOR_INPUT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.ACTION_WITH_SYMBOL
    }, {
      category: CONTROLS,
      title: controlNames.COLOR_PICKER_INPUT
    } // { category: COMPOSITES , title: 'LinkButtonWithColorInput' }, //TOOD: uncomment when there is a composite page
    ]
  },
  DynamicFieldLabeled: {
    displayName: compositeNames.DYNAMIC_FIELD_LABELED,
    uxSemantic: 'U31',
    className: 'composite-dynamic-field-labeled composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.DYNAMIC_FIELD)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.DYNAMIC_FIELD
    }]
  },
  DynamicFieldWithDescription: {
    displayName: compositeNames.DYNAMIC_FIELD_WITH_DESCRIPTION,
    uxSemantic: 'U31A',
    className: 'composite-dynamic-field-with-description',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.DYNAMIC_FIELD)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.DYNAMIC_FIELD
    }]
  },
  EditableUrlLabeled: {
    displayName: compositeNames.EDITABLE_URL_LABELED,
    uxSemantic: 'U30',
    className: 'composite-editable-url-labeled',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.EDITABLE_URL), childType.once(controlNames.HEADING)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.EDITABLE_URL
    }, {
      category: CONTROLS,
      title: controlNames.HEADING
    }]
  },
  FontFamilyPickerLabeled: {
    displayName: compositeNames.FONT_FAMILY_PICKER_LABELED,
    uxSemantic: 'C10D',
    className: 'composite-dropdown-labeled composite-with-info-icon font-family-picker-labeled',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.FONT_FAMILY_PICKER)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.FONT_FAMILY_PICKER
    }]
  },
  GooglePreviewWithRichText: {
    displayName: compositeNames.GOOGLE_PREVIEW_WITH_RICH_TEXT,
    uxSemantic: 'U32',
    className: 'composite-google-preview-with-rich-text',
    childrenTypes: [childType.once(controlNames.RICH_TEXT), childType.once(controlNames.GOOGLE_PREVIEW)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.RICH_TEXT
    }, {
      category: CONTROLS,
      title: controlNames.GOOGLE_PREVIEW
    }]
  },
  HorizontalTabsLabeled: {
    displayName: compositeNames.HORIZONTAL_TABS_LABELED,
    uxSemantic: 'C09',
    className: 'composite-horizontal-tabs-labeled',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.HORIZONTAL_TABS)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.HORIZONTAL_TABS
    }]
  },
  VerticalTabsLabeled: {
    displayName: compositeNames.VERTICAL_TABS_LABELED,
    uxSemantic: 'C09A',
    className: 'composite-vertical-tabs-labeled',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.VERTICAL_TABS)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.VERTICAL_TABS
    }]
  },
  RadioButtonsWithIllustration: {
    displayName: compositeNames.RADIO_BUTTONS_WITH_ILLUSTRATION,
    uxSemantic: 'U14',
    className: 'composite-radio-buttons-with-illustration',
    childrenTypes: [childType.once(controlNames.RADIO_BUTTONS_WITH_ILLUSTRATION)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.RADIO_BUTTONS_WITH_ILLUSTRATION
    }]
  },
  PanelContent: {
    displayName: compositeNames.PANEL_CONTENT,
    className: 'composite-panel-content',
    childrenTypes: childType.any()
  },
  PanelContentAsymmetric: {
    displayName: compositeNames.PANEL_CONTENT_ASYMMETRIC,
    className: 'composite-panel-content-asymmetric',
    childrenTypes: childType.any()
  },
  PopupTinySize: {
    displayName: compositeNames.POPUP_TINY_SIZE,
    className: 'composite-popup composite-popup-tiny-size',
    childrenTypes: [childType.once(controlNames.PANEL_HEADER), childType.once(compositeNames.PANEL_CONTENT), childType.optional(compositeNames.ACTION_SET_HORIZONTAL, compositeNames.ACTION_SET_HORIZONTAL_SPACED, compositeNames.ACTION_SET_VERTICAL)]
  },
  PopupSmallSize: {
    displayName: compositeNames.POPUP_SMALL_SIZE,
    className: 'composite-popup composite-popup-small-size',
    childrenTypes: [childType.once(controlNames.PANEL_HEADER), childType.once(compositeNames.PANEL_CONTENT), childType.optional(compositeNames.ACTION_SET_HORIZONTAL, compositeNames.ACTION_SET_HORIZONTAL_SPACED, compositeNames.ACTION_SET_VERTICAL)]
  },
  PopupMediumSize: {
    displayName: compositeNames.POPUP_MEDIUM_SIZE,
    className: 'composite-popup composite-popup-medium-size',
    childrenTypes: [childType.once(compositeNames.BIG_PANEL_HEADER, compositeNames.BIG_PANEL_HEADER_WITH_ILLUSTRATION), childType.once(compositeNames.PANEL_CONTENT), childType.optional(compositeNames.ACTION_SET_HORIZONTAL, compositeNames.ACTION_SET_HORIZONTAL_SPACED, compositeNames.ACTION_SET_VERTICAL)]
  },
  PopupLargeSize: {
    displayName: compositeNames.POPUP_LARGE_SIZE,
    className: 'composite-popup composite-popup-large-size',
    childrenTypes: [childType.once(compositeNames.BIG_PANEL_HEADER, compositeNames.BIG_PANEL_HEADER_WITH_ILLUSTRATION), childType.once(compositeNames.PANEL_CONTENT), childType.optional(compositeNames.ACTION_SET_HORIZONTAL, compositeNames.ACTION_SET_HORIZONTAL_SPACED, compositeNames.ACTION_SET_VERTICAL)]
  },
  PopupJumboSize: {
    displayName: compositeNames.POPUP_JUMBO_SIZE,
    className: 'composite-popup composite-popup-jumbo-size',
    childrenTypes: [childType.once(compositeNames.POPUP_JUMBO_MEDIA), childType.once(compositeNames.POPUP_JUMBO_CONTENT)]
  },
  PopupJumboMedia: {
    displayName: compositeNames.POPUP_JUMBO_MEDIA,
    className: 'composite-popup-jumbo-media',
    childrenTypes: childType.any()
  },
  PopupJumboContent: {
    displayName: compositeNames.POPUP_JUMBO_CONTENT,
    className: 'composite-popup-jumbo-content',
    childrenTypes: [childType.once(compositeNames.BIG_PANEL_HEADER, compositeNames.BIG_PANEL_HEADER_WITH_ILLUSTRATION), childType.once(compositeNames.PANEL_CONTENT), childType.optional(compositeNames.ACTION_SET_HORIZONTAL, compositeNames.ACTION_SET_HORIZONTAL_SPACED, compositeNames.ACTION_SET_VERTICAL)]
  },
  Preloader: {
    displayName: compositeNames.PRELOADER,
    uxSemantic: 'U05',
    className: 'composite-preloader',
    childrenTypes: [childType.once(controlNames.PRELOADER), childType.optional(controlNames.TEXT_LABEL)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.PRELOADER
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }],
    extraStyleProps: {
      height: PropTypes.number
    }
  },
  ProgressBar: {
    displayName: compositeNames.PROGRESS_BAR,
    uxSemantic: 'U06',
    className: 'composite-progress-bar',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.PROGRESS_BAR)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.PROGRESS_BAR
    }, {
      category: CONTROLS,
      title: controlNames.HEADING
    }]
  },
  ProgressBarWithIllustration: {
    displayName: compositeNames.PROGRESS_BAR_WITH_ILLUSTRATION,
    uxSemantic: 'U06A',
    className: 'composite-progress-bar-with-illustration',
    childrenTypes: [childType.once(controlNames.ILLUSTRATION), childType.once(compositeNames.PROGRESS_BAR)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.ILLUSTRATION
    }, {
      category: CONTROLS,
      title: controlNames.PROGRESS_BAR
    }, {
      category: CONTROLS,
      title: controlNames.HEADING
    }]
  },
  ProgressBarWithIllustrationVertical: {
    displayName: compositeNames.PROGRESS_BAR_WITH_ILLUSTRATION_VERTICAL,
    uxSemantic: 'U06B',
    className: 'composite-progress-bar-with-illustration-vertical',
    childrenTypes: [childType.once(controlNames.ILLUSTRATION), childType.once(compositeNames.PROGRESS_BAR)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.ILLUSTRATION
    }, {
      category: CONTROLS,
      title: controlNames.PROGRESS_BAR
    }, {
      category: CONTROLS,
      title: controlNames.HEADING
    }]
  },
  PromotionalList: {
    displayName: compositeNames.PROMOTIONAL_LIST,
    uxSemantic: 'U03',
    className: 'composite-promotional-list',
    childrenTypes: [childType.once(controlNames.PROMOTIONAL_LIST)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.PROMOTIONAL_LIST
    }]
  },
  RichTextWithIllustration: {
    displayName: compositeNames.RICH_TEXT_WITH_ILLUSTRATION,
    uxSemantic: 'U02',
    className: 'composite-rich-text-with-illustration',
    childrenTypes: [childType.optional(controlNames.ILLUSTRATION), childType.once(compositeNames.RICH_TEXT_LABELED, compositeNames.RICH_TEXT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.ILLUSTRATION
    }, {
      category: CONTROLS,
      title: controlNames.TEXT
    }, {
      category: CONTROLS,
      title: controlNames.RICH_TEXT
    } // { category: COMPOSITES, title: 'RichTextLabeled' }, //TODO: uncomment when there's a composite page
    ]
  },
  RichTextWithIllustrationVertical: {
    displayName: compositeNames.RICH_TEXT_WITH_ILLUSTRATION_VERTICAL,
    uxSemantic: 'U02A',
    className: 'composite-rich-text-with-illustration-vertical',
    childrenTypes: [childType.optional(controlNames.ILLUSTRATION), childType.once(compositeNames.RICH_TEXT_LABELED, compositeNames.RICH_TEXT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.ILLUSTRATION
    }, {
      category: CONTROLS,
      title: controlNames.TEXT
    }, {
      category: CONTROLS,
      title: controlNames.RICH_TEXT
    } // { category: COMPOSITES, title: 'RichTextLabeled' }, //TODO: uncomment when there's a composite page
    ]
  },
  RadioButtonsLabeled: {
    displayName: compositeNames.RADIO_BUTTONS_LABELED,
    uxSemantic: 'C14',
    className: 'composite-radio-buttons-labeled composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.RADIO_BUTTONS)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.RADIO_BUTTONS
    }]
  },
  RadioButtons: {
    displayName: compositeNames.RADIO_BUTTONS,
    uxSemantic: 'C14A',
    className: 'composite-radio-buttons',
    childrenTypes: [childType.once(controlNames.RADIO_BUTTONS)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.RADIO_BUTTONS
    }]
  },
  RichText: {
    displayName: compositeNames.RICH_TEXT,
    uxSemantic: 'C22',
    className: 'composite-rich-text',
    childrenTypes: [childType.once(controlNames.RICH_TEXT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.RICH_TEXT
    }]
  },
  RichTextLabeled: {
    displayName: compositeNames.RICH_TEXT_LABELED,
    uxSemantic: 'C22A',
    className: 'composite-rich-text-labeled',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL, controlNames.CONTROL_HEADER), childType.once(controlNames.RICH_TEXT), childType.optional(controlNames.BUTTON), childType.optional(controlNames.BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.RICH_TEXT
    }, {
      category: CONTROLS,
      title: controlNames.TEXT
    }, {
      category: CONTROLS,
      title: controlNames.BUTTON
    }]
  },
  TextInput: {
    displayName: compositeNames.TEXT_INPUT,
    uxSemantic: 'C02A',
    className: 'composite-text-input',
    childrenTypes: [childType.once(controlNames.TEXT_INPUT, controlNames.NUMERIC_INPUT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_INPUT
    }, {
      category: CONTROLS,
      title: controlNames.NUMERIC_INPUT
    }]
  },
  TextInputLabeled: {
    displayName: compositeNames.TEXT_INPUT_LABELED,
    uxSemantic: 'C02',
    className: 'composite-text-input-labeled composite-with-info-icon composite-with-char-limit',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.optional(controlNames.CHAR_LIMIT), childType.once(controlNames.TEXT, controlNames.TEXT_LABEL, controlNames.DROP_DOWN), childType.once(controlNames.TEXT_INPUT, controlNames.NUMERIC_INPUT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.CHAR_LIMIT
    }, {
      category: CONTROLS,
      title: controlNames.TEXT
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.DROP_DOWN
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_INPUT
    }, {
      category: CONTROLS,
      title: controlNames.NUMERIC_INPUT
    }],
    compositePageExist: true
  },
  TextInputMultilineWithButton: {
    displayName: compositeNames.TEXT_INPUT_MULTI_LINE_WITH_BUTTON,
    uxSemantic: 'C18A',
    className: 'composite-text-input-multiline-with-button',
    childrenTypes: [childType.once(controlNames.TEXT_INPUT_MULTI_LINE_WITH_BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_INPUT_MULTI_LINE_WITH_BUTTON
    }]
  },
  TextInputMultilineWithButtonLabeled: {
    displayName: compositeNames.TEXT_INPUT_MULTI_LINE_WITH_BUTTON_LABELED,
    uxSemantic: 'C18',
    className: 'composite-text-input-multiline-with-button-labeled composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.TEXT_INPUT_MULTI_LINE_WITH_BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_INPUT_MULTI_LINE_WITH_BUTTON
    }]
  },
  TextInputMultiline: {
    displayName: compositeNames.TEXT_INPUT_MULTI_LINE,
    uxSemantic: 'C18B',
    className: 'composite-text-input-multiline',
    childrenTypes: [childType.once(controlNames.TEXT_INPUT_MULTI_LINE)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_INPUT_MULTI_LINE
    }]
  },
  TextInputMultilineLabeled: {
    displayName: compositeNames.TEXT_INPUT_MULTI_LINE_LABELED,
    uxSemantic: 'C18C',
    className: 'composite-text-input-multiline-labeled composite-with-info-icon composite-with-char-limit',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.optional(controlNames.CHAR_LIMIT), childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.TEXT_INPUT_MULTI_LINE)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.CHAR_LIMIT
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_INPUT_MULTI_LINE
    }]
  },
  ToggleSwitch: {
    displayName: compositeNames.TOGGLE_SWITCH,
    uxSemantic: 'C21',
    className: 'composite-toggle-switch',
    childrenTypes: [childType.once(controlNames.TOGGLE_SWITCH)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TOGGLE_SWITCH
    }],
    compositePageExists: true
  },
  ToggleSwitchWithSelectiveInput: {
    displayName: compositeNames.TOGGLE_SWITCH_WITH_SELECTIVE_INPUT,
    uxSemantic: 'C28',
    className: 'composite-toggle-switch-with-selective-input',
    childrenTypes: [childType.once(compositeNames.TOGGLE_SWITCH), childType.optional(compositeNames.TEXT_INPUT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TOGGLE_SWITCH
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_INPUT
    }]
  },
  SecondaryMedia: {
    displayName: compositeNames.SECONDARY_MEDIA,
    uxSemantic: 'C05A',
    className: 'composite-secondary-media',
    childrenTypes: [childType.once(controlNames.SECONDARY_MEDIA_IMAGE), childType.once(controlNames.BUTTON), childType.optional(controlNames.BUTTON, controlNames.CONTEXT_MENU)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.SECONDARY_MEDIA_IMAGE
    }, {
      category: CONTROLS,
      title: controlNames.BUTTON
    }, {
      category: CONTROLS,
      title: controlNames.CONTEXT_MENU
    }]
  },
  SecondaryMediaLabeled: {
    displayName: compositeNames.SECONDARY_MEDIA_LABELED,
    uxSemantic: 'C05',
    className: 'composite-secondary-media-labeled composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.SECONDARY_MEDIA_IMAGE), childType.once(controlNames.BUTTON), childType.optional(controlNames.BUTTON, controlNames.CONTEXT_MENU)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.SECONDARY_MEDIA_IMAGE
    }, {
      category: CONTROLS,
      title: controlNames.BUTTON
    }, {
      category: CONTROLS,
      title: controlNames.CONTEXT_MENU
    }]
  },
  SectionDividerWithInfoIcon: {
    displayName: compositeNames.SECTION_DIVIDER_WITH_INFO_ICON,
    uxSemantic: 'C06',
    className: 'composite-section-divider-with-info-icon composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.SECTION_DIVIDER)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.SECTION_DIVIDER
    }]
  },
  SliderLabeled: {
    displayName: compositeNames.SLIDER_LABELED,
    uxSemantic: 'C25',
    className: 'composite-slider-labeled composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.SLIDER)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.SLIDER
    }],
    compositePageExists: true
  },
  Slider: {
    displayName: compositeNames.SLIDER,
    uxSemantic: 'C25A',
    className: 'composite-slider',
    childrenTypes: [childType.once(controlNames.SLIDER)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.SLIDER
    }]
  },
  ColorPickerInput: {
    displayName: compositeNames.COLOR_PICKER_INPUT,
    uxSemantic: 'C38A',
    className: 'composite-color-picker-input',
    childrenTypes: [childType.once(controlNames.OPACITY_PICKER, controlNames.SLIDER), childType.once(controlNames.COLOR_PICKER_INPUT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.SLIDER
    }, {
      category: CONTROLS,
      title: controlNames.COLOR_PICKER_INPUT
    }, {
      category: CONTROLS,
      title: controlNames.OPACITY_PICKER
    }]
  },
  ColorPickerInputLabeled: {
    displayName: compositeNames.COLOR_PICKER_INPUT_LABELED,
    uxSemantic: 'C38',
    className: 'composite-color-picker-input-labeled',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL), childType.once(compositeNames.COLOR_PICKER_INPUT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.COLOR_PICKER_INPUT
    }]
  },
  ColorSelectLabeled: {
    displayName: compositeNames.COLOR_SELECT_LABELED,
    uxSemantic: 'C39',
    className: 'composite-color-select-labeled',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.COLOR_PICKER_INPUT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.COLOR_PICKER_INPUT
    }]
  },
  Thumbnails: {
    displayName: compositeNames.THUMBNAILS,
    uxSemantic: 'C07',
    className: 'composite-thumbnails composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.optional(controlNames.TEXT_LABEL), childType.once(controlNames.THUMBNAILS)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.INFO_ICON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.THUMBNAILS
    }],
    compositePageExists: true
  },
  ThumbnailButtonGroup: {
    displayName: compositeNames.THUMBNAIL_BUTTON_GROUP,
    uxSemantic: 'C07-A',
    className: 'composite-thumbnail-button-group',
    childrenTypes: [childType.optional(controlNames.TEXT_LABEL), childType.once(controlNames.THUMBNAIL_BUTTON_GROUP, controlNames.THUMBNAIL_COLOR_INPUT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.THUMBNAIL_BUTTON_GROUP
    }, {
      category: CONTROLS,
      title: controlNames.THUMBNAIL_COLOR_INPUT
    }]
  },
  TextFormatting: {
    displayName: compositeNames.TEXT_FORMATTING,
    uxSemantic: 'C61',
    className: 'composite-text-formatting',
    childrenTypes: [childType.optional(controlNames.TEXT_BOLD_BUTTON), childType.optional(controlNames.TEXT_ITALIC_BUTTON), childType.optional(controlNames.TEXT_UNDERLINE_BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_BOLD_BUTTON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_ITALIC_BUTTON
    }, {
      category: CONTROLS,
      title: controlNames.TEXT_UNDERLINE_BUTTON
    }]
  },
  UploadButton: {
    displayName: compositeNames.UPLOAD_BUTTON,
    uxSemantic: 'C20B',
    className: 'composite-upload-button',
    childrenTypes: [childType.once(controlNames.UPLOAD_BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.UPLOAD_BUTTON
    }]
  },
  UploadButtonLabeled: {
    displayName: compositeNames.UPLOAD_BUTTON_LABELED,
    uxSemantic: 'C20A',
    className: 'composite-upload-button-labeled',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.UPLOAD_BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    }, {
      category: CONTROLS,
      title: controlNames.UPLOAD_BUTTON
    }]
  },
  NumericInput: {
    displayName: compositeNames.NUMERIC_INPUT,
    uxSemantic: 'C26',
    className: 'composite-numeric-input',
    childrenTypes: [childType.once(controlNames.NUMERIC_INPUT)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.NUMERIC_INPUT
    }]
  },
  InputWithDropDown: {
    displayName: compositeNames.INPUT_WITH_DROP_DOWN,
    className: 'composite-input-with-drop-down',
    childrenTypes: [childType.once(controlNames.TEXT_INPUT, controlNames.NUMERIC_INPUT), childType.once(controlNames.DROP_DOWN)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_INPUT
    }, {
      category: CONTROLS,
      title: controlNames.NUMERIC_INPUT
    }, {
      category: CONTROLS,
      title: controlNames.DROP_DOWN
    }]
  },
  InputWithDropDownLabeled: {
    displayName: compositeNames.INPUT_WITH_DROP_DOWN_LABELED,
    className: 'composite-input-with-drop-down-labeled',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(compositeNames.INPUT_WITH_DROP_DOWN)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_LABEL
    } //{ category: COMPOSITES , title: 'InputWithDropDown' }, TODO: uncomment when there's a composite page
    ]
  },
  Stepper: {
    displayName: compositeNames.STEPPER,
    className: 'composite-stepper',
    childrenTypes: [childType.once(controlNames.STEPPER)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.STEPPER
    }]
  },
  TimeRange: {
    displayName: compositeNames.TIME_RANGE,
    className: 'composite-time-range',
    childrenTypes: [childType.optional(controlNames.TEXT_INPUT), childType.optional(controlNames.TEXT), childType.optional(controlNames.ICON_BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.TEXT_INPUT
    }, {
      category: CONTROLS,
      title: controlNames.TEXT
    }, {
      category: CONTROLS,
      title: controlNames.ICON_BUTTON
    }]
  },
  DateRange: {
    displayName: compositeNames.DATE_RANGE,
    className: 'composite-date-range',
    childrenTypes: [childType.optional(controlNames.DATE_PICKER_INPUT), childType.optional(controlNames.TEXT), childType.optional(controlNames.ICON_BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.DATE_PICKER_INPUT
    }, {
      category: CONTROLS,
      title: controlNames.TEXT
    }, {
      category: CONTROLS,
      title: controlNames.ICON_BUTTON
    }]
  },
  CheckboxIndented: {
    displayName: compositeNames.CHECKBOX_INDENTED,
    className: 'checkbox-indented',
    childrenTypes: [childType.optional(compositeNames.CHECKBOX_INDENTED), childType.optional(compositeNames.CHECKBOX_WITH_INFO_ICON)]
  },
  SecondaryMediaSmallLabeled: {
    displayName: compositeNames.SECONDARY_MEDIA_SMALL_LABELED,
    className: 'secondary-media-small-labeled composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.CONTROL_HEADER), childType.once(controlNames.SECONDARY_MEDIA_IMAGE), childType.optional(controlNames.ICON_BUTTON, controlNames.BUTTON), childType.once(controlNames.ICON_BUTTON, controlNames.BUTTON)],
    includedComponents: [{
      category: CONTROLS,
      title: controlNames.CONTROL_HEADER
    }, {
      category: CONTROLS,
      title: controlNames.SECONDARY_MEDIA_IMAGE
    }, {
      category: CONTROLS,
      title: controlNames.ICON_BUTTON
    }, {
      category: CONTROLS,
      title: controlNames.BUTTON
    }]
  },
  TextInputWithSuffix: {
    displayName: compositeNames.TEXT_INPUT_WITH_SUFFIX,
    className: 'text-input-with-suffix',
    childrenTypes: [childType.optional(controlNames.CONTROL_HEADER), childType.once(controlNames.TEXT_INPUT), childType.once(controlNames.BUTTON, controlNames.ICON_BUTTON), childType.optional(controlNames.BUTTON, controlNames.ICON_BUTTON)]
  },
  RadioButtonsWithIllustrationSmall: {
    displayName: compositeNames.RADIO_BUTTONS_WITH_ILLUSTRATION_SMALL,
    className: 'radio-buttons-with-illustration-small',
    childrenTypes: [childType.once(controlNames.RADIO_BUTTONS_WITH_ILLUSTRATION)]
  }
};
export default {
  CompositeDefinitions: compositeDefinitions,
  ResponsiveCompositeDefinitions: responsiveComposites,
  AllCompositeDefinitions: Object.assign({}, compositeDefinitions, responsiveComposites)
};